import React from 'react';
import { Box, Typography } from '@mui/material';

import styles from './ExportFileHeader.styles';
import SearchInput from '../../../../components/inputs/SearchInput';
import OutboxIcon from '@mui/icons-material/Outbox';

const ExportFileHeader = ({
  title = 'File Logs',
  onSearch,
  searchQuery,
  setSearchQuery,
}) => (
  <Box sx={styles.headerRow}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <OutboxIcon sx={{ ...styles.pageTitle, mr: 1 }} />
      <Typography sx={styles.pageTitle}>{title}</Typography>
    </Box>

    <SearchInput
      value={searchQuery}
      onChange={setSearchQuery}
      onSearch={onSearch}
    />
  </Box>
);

export default ExportFileHeader;
